import { Logo } from '@convergence/components';
import {
  CheckIcon,
  CopyIcon,
  InfoIcon,
  PencilSimpleIcon,
  PlusIcon,
  TrashIcon,
  XIcon
} from '@phosphor-icons/react';
import { observer } from 'mobx-react';
import { useState } from 'react';
import { useCreateNotebookMutation } from '../api/mutations/createNotebook';
import { useDeleteNotebookMutation } from '../api/mutations/deleteNotebook';
import { useDuplicateNotebookMutation } from '../api/mutations/duplicateNotebook';
import { useEditNotebookTitleMutation } from '../api/mutations/editNotebookTitle';
import { useGetNotebookQuery } from '../api/queries/notebook';
import { useNotebooksQuery } from '../api/queries/notebooks';
import { HomeStore } from '../stores/HomeStore';
import { NotebookContainer } from './NotebookContainer';
import { useErrorToast } from '../lib/useErrorToast';
import { Popover } from './Popover';

interface NotebookListProps {
  store: HomeStore;
  // webSocketClient: WebSocketClient;
  className?: string;
}

export const NotebookList = observer(
  ({ store, className }: NotebookListProps) => {
    const { data, error: err } = useNotebooksQuery();
    console.log(err);
    const createNotebookMutation = useCreateNotebookMutation();
    const { mutateAsync: duplicateNotebook } = useDuplicateNotebookMutation();
    const { mutateAsync: deleteNotebook } = useDeleteNotebookMutation();
    const { mutateAsync: editNotebookTitle, error: editError } =
      useEditNotebookTitleMutation();
    const [notebookToEdit, setNotebookToEdit] = useState<string | null>(null);
    const [newTitle, setNewTitle] = useState('');

    useErrorToast(editError);

    const { data: selectedNotebook, error } = useGetNotebookQuery(
      store.selectedNotebookTitle || undefined
    );

    const createNotebook = async (language: string) => {
      const res = await createNotebookMutation.mutateAsync({ language });
      store.setSelectedNotebookTitle(res.notebook.title);
      return res.notebook;
    };

    return (
      <div className={`${className || ''} h-full`}>
        {!selectedNotebook && (
          <>
            <div className="py-2 flex justify-between">
              <h2 className="text-lg">notebooks</h2>
              <button
                className="px-2 flex gap-2 items-center bg-black text-white"
                onClick={() => createNotebook('bash')}
              >
                <PlusIcon size={16} />
              </button>
            </div>
            {data?.notebooks &&
              data.notebooks.map((n) => (
                <div
                  className="rounded-sm flex justify-between items-center hover:bg-neutral-200"
                  key={n.id}
                >
                  {notebookToEdit === n.id ? (
                    <div className="p-2 flex-grow flex gap-2 items-center">
                      {n.readonly && <Logo className="inline w-3 h-3" />}
                      <div>
                        <input
                          type="text"
                          value={newTitle}
                          autoFocus
                          onChange={(e) => {
                            setNewTitle(e.target.value);
                          }}
                        />
                        <button
                          className="p-1 text-neutral-500 hover:text-black"
                          onClick={async () => {
                            try {
                              await editNotebookTitle({
                                data: { title: newTitle },
                                id: notebookToEdit
                              });
                              setNotebookToEdit(null);
                            } catch (err) {}
                          }}
                        >
                          <CheckIcon size={16} />
                        </button>
                        <button
                          className="p-1 text-neutral-500 hover:text-black"
                          onClick={() => setNotebookToEdit(null)}
                        >
                          <XIcon size={16} />
                        </button>
                      </div>
                    </div>
                  ) : (
                    <div
                      className="p-2 flex-grow flex gap-2 items-center"
                      onClick={() => {
                        store.setSelectedNotebookTitle(n.title);
                      }}
                    >
                      {n.readonly && <Logo className="inline w-3 h-3" />}
                      <p>{n.title}</p>
                    </div>
                  )}

                  <div>
                    <button
                      className="p-2 text-neutral-500 hover:text-black"
                      onClick={async () =>
                        await duplicateNotebook({ title: n.title })
                      }
                    >
                      <CopyIcon size={18} />
                    </button>
                    {!n.readonly && (
                      <>
                        <button
                          className="p-2 text-neutral-500 hover:text-black"
                          onClick={() => {
                            setNotebookToEdit(n.id);
                            setNewTitle(n.title);
                          }}
                        >
                          <PencilSimpleIcon size={18} />
                        </button>
                        <button
                          className="p-2 text-neutral-500 hover:text-black"
                          onClick={async () => await deleteNotebook(n.title)}
                        >
                          <TrashIcon size={18} />
                        </button>
                      </>
                    )}
                  </div>
                </div>
              ))}
          </>
        )}
        {selectedNotebook && (
          <NotebookContainer
            notebook={selectedNotebook}
            tinkerBoxConnection={store.tinkerBoxConnection}
            homeStore={store}
            editNotebookTitle={async (id: string, newTitle: string) =>
              await editNotebookTitle({ data: { title: newTitle }, id })
            }
          />
        )}
      </div>
    );
  }
);
